export { default } from './PrimaryText';
